// ***********************************************
// ********** EDIT CLIENT PROFILE UTILS **********
// ***********************************************

import PRONOUNS from 'constants/pronouns.const';
import asArray from 'utils/arrays/asArray.util';

// Generate dropdown options from pronouns constant
export const pronounsOptions = (t) =>
  PRONOUNS.map((p) => ({
    description: p,
    extra: p,
  }));

export const clientSourceOptions = (t) => [
  {
    description: t('scheduler.editClientProfile.sources.facebook'),
    extra: 'facebook',
  },
  {
    description: t('scheduler.editClientProfile.sources.instagram'),
    extra: 'instagram',
  },
  {
    description: t('scheduler.editClientProfile.sources.google'),
    extra: 'google_ad',
  },
  {
    description: t('scheduler.editClientProfile.sources.newspaper'),
    extra: 'newspaper_ad',
  },
  {
    description: t('scheduler.editClientProfile.sources.flyer'),
    extra: 'flyer_leaflet',
  },
  {
    description: t('scheduler.editClientProfile.sources.recommendAFriend'),
    extra: 'recommend_a_friend',
  },
  {
    description: t('scheduler.editClientProfile.sources.referral'),
    extra: 'referral',
  },
  {
    description: t('scheduler.editClientProfile.sources.reviewSite'),
    extra: 'review_site',
  },
  {
    description: t('scheduler.editClientProfile.sources.other'),
    extra: 'other',
  },
];

// MONTH_NAMES generates an array of month names for a given locale using Intl.DateTimeFormat.
// It creates an array of length 12 (for the 12 months)
// and formats a date for each month (using a fixed year and day to avoid leap-year issues).
// The result is an array of localized month names that can be used in dropdowns or other UI elements. The default locale is 'en-GB',
// but it can be overridden by passing a different locale string as an argument.
const MONTH_NAMES = (locale = 'en-GB') => Array.from({ length: 12 }, (_, i) => new Intl.DateTimeFormat(locale, { month: 'long' }).format(new Date(2020, i, 1)));

export const dropdownMonthOptions = (t, locale) => {
  const description = t('scheduler.editClientProfile.monthPlaceholder');

  return [{ description, extra: '' }, ...MONTH_NAMES(locale).map((m, i) => ({ description: m, extra: String(i + 1) }))];
};

// counts for months: keep February 29 so leap-day birthdays can be selected
const DAYS_IN_MONTH_COUNT = [0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export const dayOptionsByMonth = (t) => {
  const label = t('scheduler.editClientProfile.dayPlaceholder');

  return DAYS_IN_MONTH_COUNT.map((count) => [{ value: null, label }, ...Array.from({ length: count }, (_, i) => ({ value: i + 1, label: String(i + 1) }))]);
};

/**
 * Filters and maps client tags to backend format: [{ id }]
 * @param {Array} tags
 * @returns {Array}
 */
export const transformClientTagsForBackend = (tags) =>
  asArray(tags)
    .filter((tag) => tag?.id)
    .map((tag) => ({ id: tag.id }));
// ***********************************************
